// src/modules/components/inkind/export-button.jsx
import * as React from 'react';
import { useState } from 'react';
import { Button } from 'react-admin';
import { CircularProgress } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import { useNotify } from 'react-admin';

const ExportButton = ({ 
  onClick, 
  data, 
  label = "Export", 
  disabled = false,
  size = "small",
  variant = "text"
}) => {
  const [exporting, setExporting] = useState(false);
  const notify = useNotify();

  const handleClick = async () => {
    if (!data || data.length === 0) {
      notify('No data to export', { type: 'warning' });
      return;
    }

    setExporting(true);
    try {
      await onClick();
    } catch (error) {
      console.error('Export error:', error);
      notify('Error exporting data', { type: 'error' });
    } finally {
      setExporting(false);
    }
  };

  return (
    <Button
      size={size}
      variant={variant}
      onClick={handleClick}
      disabled={disabled || exporting || !data || data.length === 0}
      label={exporting ? 'Exporting...' : label}
      sx={{
        minWidth: 'auto',
        '& .MuiButton-startIcon': {
          marginRight: 1,
        }
      }}
    >
      {exporting ? <CircularProgress size={16} /> : <DownloadIcon />}
    </Button>
  );
};

export default ExportButton;